import SvgIcon from '@mui/material/SvgIcon'
import React from 'react'

import { IconProps } from './types'

const DryingIcon: React.FC<IconProps> = (props = {}) => {
  const { color, fontSize, style, ...rest } = props

  return (
    <SvgIcon viewBox="0 0 24 24" style={{ color, fontSize, ...style }} {...rest}>
      <mask x="-1.83" y="-1.43" width="27.35" height="27.35" />
      <path d="M12.65,21.66A8.88,8.88,0,0,1,6.19,19a8.66,8.66,0,0,1-2.66-6.37A8.42,8.42,0,0,1,4,9.87,9.37,9.37,0,0,1,5.35,7.3l-4-4a1.07,1.07,0,0,1-.32-.79,1.08,1.08,0,0,1,.32-.8,1.05,1.05,0,0,1,.79-.32,1.08,1.08,0,0,1,.8.32L22.33,21.09a1.16,1.16,0,0,1,0,1.6,1,1,0,0,1-.79.31,1.07,1.07,0,0,1-.8-.31L18,20a9.51,9.51,0,0,1-2.5,1.27A9.24,9.24,0,0,1,12.65,21.66Zm0-2.28a6.62,6.62,0,0,0,1.95-.28,7.49,7.49,0,0,0,1.75-.8L7,9a6.92,6.92,0,0,0-.87,1.83,6.57,6.57,0,0,0-.27,1.88,6.43,6.43,0,0,0,2,4.76A6.65,6.65,0,0,0,12.65,19.38Zm6.44-13a8.85,8.85,0,0,1,2.32,3.89,8.75,8.75,0,0,1,.1,4.4,1,1,0,0,1-.4.63,1.2,1.2,0,0,1-.71.23.94.94,0,0,1-.9-.51,1.53,1.53,0,0,1-.13-1.09,5.08,5.08,0,0,0-.14-3.15A7.29,7.29,0,0,0,17.49,8L12.65,3.2,10.94,4.88a1,1,0,0,1-.8.3A1.14,1.14,0,0,1,9,4a1,1,0,0,1,.34-.78l2.11-2.08A1.48,1.48,0,0,1,12,.81a1.76,1.76,0,0,1,.63-.12,1.5,1.5,0,0,1,.62.13,1.9,1.9,0,0,1,.57.36Z" />
    </SvgIcon>
  )
}
export default DryingIcon
